<template>
    <div>

        <div class="app-customizer">
            <v-btn
                icon
                class="app-customizer-toggler rounded-0"
                :class="'rounded-l-lg'"
                color="white"
                large
                @click="save()"
            >
                <v-icon size="25">
                {{ icons.mdiContentSaveOutline }}
                </v-icon>
            </v-btn>
      </div>
        <v-card v-if="localProjectData">
            <v-card-title class="pb-2">
                {{ localProjectData.job_number }} - {{ localProjectData.job_name }} - {{ localProjectData.country }}
                <v-spacer></v-spacer>
                <div class="d-flex flex-column">
                    <div
                        class="text-right"
                    >
                        <v-icon
                            color="error"
                            @click="deleteQuestionnaireDialogOpen = true"
                        >
                            {{icons.mdiTrashCanOutline }}
                        </v-icon>
                    </div>
                    <span class="text-caption">Last updated: {{new Date(localProjectData.updated_at).toUTCString()}}</span>
                </div>
            </v-card-title>
            <v-dialog
                v-model="deleteQuestionnaireDialogOpen"
                width="500"
                @click:outside="deleteQuestionnaireDialogOpen = false"
                >

                <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                        Confirm
                    </v-card-title>
                    <v-card-text>
                        Are you sure you want to start from scratch?
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            text
                            @click="deleteQuestionnaireDialogOpen = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            outlined
                            color="primary"
                            :loading="deleteQuestionnaireLoading"
                            @click="deleteQuestionnaire(localProjectData.id)"
                        >
                            OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-card-text>
                <v-card flat>
                        <v-toolbar
                        flat
                            >

                            <v-toolbar-title>
                                <v-tabs
                                    v-model="surveyTab"
                                    align-with-title
                                    >
                                    <v-tabs-slider color="warning"></v-tabs-slider>
                                    <v-tab
                                        class="ml-0"
                                        v-if="projectPermission"
                                    >
                                        Designer
                                    </v-tab>
                                    <!--<v-tab
                                        class="ml-0"
                                        v-if="projectPermission"
                                    >
                                        Translation
                                    </v-tab>-->
                                    <v-tab
                                        class="ml-0"
                                        v-if="projectPermission"
                                        @click="getVersions"
                                    >
                                        Validation
                                    </v-tab>
                                    <v-tab
                                        class="ml-0"
                                        v-if="prgmPermission"
                                    >
                                        JSON Viewer
                                    </v-tab>
                                </v-tabs>
                            </v-toolbar-title>

                            <v-spacer></v-spacer>
                            <div v-if="surveyTab == 0">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn
                                            color="primary"
                                            outlined
                                            icon
                                            class="rounded-lg mx-1"
                                            large
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="isProjectInfoDialogOpen = true"
                                        >
                                            <v-icon size="30">
                                                {{ icons.mdiInformationOutline }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Project Information</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn
                                            color="warning"
                                            outlined
                                            icon
                                            class="rounded-lg mx-1"
                                            large
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="isQuotaDialogOpen = true"
                                        >
                                            <v-icon size="30">
                                                {{ icons.mdiCartPercent }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Quotas</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn
                                            color="info"
                                            outlined
                                            icon
                                            class="rounded-lg mx-1"
                                            large
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="isPaperQuestionnaireDialogOpen = true"
                                        >
                                            <v-icon size="30">
                                                {{ icons.mdiFileWordOutline }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Download Paper Questionnaire</span>
                                </v-tooltip>
                            </div>

                            <!-- <div v-if="surveyTab == 1">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="warning"
                                            outlined
                                            icon
                                            class="rounded-lg mx-1"
                                            large
                                            @click="downloadTranslation"
                                            v-bind="attrs"
                                            v-on="on">

                                            <v-icon size="30">
                                                {{ icons.mdiDownloadBoxOutline }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Download Translation</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn
                                            color="primary"
                                            outlined
                                            icon
                                            class="rounded-lg mx-1"
                                            large
                                            :loading="isUploadSelecting"
                                            @click="onUploadClick"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon size="30">
                                                {{ icons.mdiFolderOpenOutline  }}
                                            </v-icon>
                                        </v-btn>

                                        <input
                                            ref="uploader"
                                            class="d-none"
                                            type="file"
                                            accept=".csv*"
                                            @change="uploadTranslation"
                                        >
                                    </template>
                                    <span>Upload Translation</span>
                                </v-tooltip>


                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="info"
                                            outlined
                                            icon
                                            class="rounded-lg mx-1"
                                            large
                                            @click="isTranslationDialogOpen = true"
                                            v-bind="attrs"
                                            v-on="on">

                                            <v-icon size="30">
                                                {{ icons.mdiTranslate }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Automated Translation</span>
                                </v-tooltip>

                            </div> -->
                            <div v-if="surveyTab == 1">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="primary"
                                            outlined
                                            icon
                                            class="rounded-lg mx-1"
                                            large
                                            @click="validationConfirmed"
                                            v-bind="attrs"
                                            v-on="on">

                                            <v-icon size="30">
                                                {{ icons.mdiContentSaveCheckOutline }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Validate</span>
                                </v-tooltip>

                            </div>

                        </v-toolbar>


                        <v-tabs-items v-model="surveyTab">
                            <v-tab-item>
                                <v-card-text v-if="localProjectData.json && localProjectData.language">
                                    <v-list v-for="(section, index) in localProjectData.json.pages"
                                        :key="index"
                                        two-line
                                    >
                                        <v-list-item-title>
                                            <span
                                            class="step-cursor"
                                                @click="sectionClick(section, index)"
                                            >
                                                {{section.name}}
                                            </span>

                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="openQuestionType(index)"
                                                    >
                                                        <v-icon>
                                                            {{ icons.mdiPlus }}
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Add question to the {{section.name}} section</span>
                                            </v-tooltip>

                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="appendSection(index)"
                                                    >
                                                        <v-icon>
                                                            {{ icons.mdiPlaylistPlus }}
                                                        </v-icon>

                                                    </v-btn>
                                                </template>
                                                <span>Add new section below</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="deleteSection(index)"
                                                    >
                                                        <v-icon>
                                                            {{ icons.mdiTrashCanOutline }}
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Delete {{section.name}} section</span>
                                            </v-tooltip>
                                        </v-list-item-title>

                                        <draggable
                                            :list="section.elements"
                                            class="list-group"
                                            group="section"
                                            :animation="200"
                                            ghost-class="ghost-card"
                                            handle=".card-cursor"
                                            @end="resetQuestionNumber(index)"
                                            :scroll-sensitivity="200"
                                            :force-fallback="true"
                                        >
                                            <v-card
                                                class="mx-auto step-cursor"
                                                outlined
                                                :class="item.quota || item.statements?'alert':'regular'"
                                                v-for="(item, indexElement) in section.elements"
                                                :key="indexElement"
                                            >
                                            <v-banner
                                                single-line
                                                height="30px"
                                                v-if="item.quota || item.statements"
                                            >
                                                <v-icon
                                                slot="icon"
                                                color="warning"
                                                small
                                                >
                                                {{ item.quota ? icons.mdiLockOpenAlertOutline : icons.mdiClipboardAlertOutline }}
                                                </v-icon>
                                                {{ item.quota ? "Don't forget to update quotas" : "Don't forget to update the different statements" }}
                                            </v-banner>

                                                <v-row dense class="justify-center">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon class="card-cursor"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >{{icons.mdiDotsHorizontal}}</v-icon>
                                                        </template>
                                                            <span>Move Element</span>
                                                    </v-tooltip>
                                                </v-row>
                                                <div
                                                    v-if="item.type === 'group'"
                                                >

                                                <v-list-item class="d-flex">
                                                    <v-list-item-content>
                                                        <v-card
                                                            class="mx-auto step-cursor"
                                                            outlined
                                                                v-for="(groupQuestion, indexGroupQuestion) in item.elements"
                                                                :key="indexGroupQuestion"
                                                            >
                                                            <v-list-item
                                                                class="list-group-item"
                                                            >
                                                            <!-- Uncomment if need to add option to have question being visible or not in paper questionnaire -->

                                                            <v-checkbox
                                                                v-model="groupQuestion.visible"
                                                            ></v-checkbox>
                                                                <v-list-item-content
                                                                    @click="questionClick(groupQuestion, index, indexElement, indexGroupQuestion)"
                                                                >
                                                                    <v-list-item-title>{{groupQuestion.valueName}} - {{ groupQuestion.name }}</v-list-item-title>

                                                                    <v-tooltip bottom v-if="groupQuestion.title">
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-list-item-subtitle
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                            >
                                                                                <span v-html="groupQuestion.title[localProjectData.language.code]"></span>
                                                                            </v-list-item-subtitle>
                                                                        </template>
                                                                        <span>{{getContentTooltip(groupQuestion.title, localProjectData.content, localProjectData.language.code)}}</span>
                                                                    </v-tooltip>
                                                                    <v-tooltip bottom v-if="groupQuestion.html">
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-list-item-subtitle
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                            >
                                                                                <span v-html="groupQuestion.html[localProjectData.language.code]"></span>
                                                                            </v-list-item-subtitle>
                                                                        </template>
                                                                        <span>{{getContentTooltip(groupQuestion.html, localProjectData.content, localProjectData.language.code)}}</span>
                                                                    </v-tooltip>
                                                                </v-list-item-content>

                                                            </v-list-item>
                                                        </v-card>
                                                    </v-list-item-content>
                                                    <v-list-item-icon @click.stop="openDuplicateDialog(item, index)" :disabled="dialogOpen" class="align-self-center">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-bind="attrs" v-on="on">{{ icons.mdiContentCopy }}</v-icon>
                                                        </template>
                                                        <span>Duplicate</span>
                                                    </v-tooltip>
                                                    </v-list-item-icon>
                                                    <v-list-item-icon class="align-self-center">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                @click="deleteElement(index, indexElement)"
                                                                v-bind="attrs"
                                                                v-on="on">{{icons.mdiDeleteOutline}}</v-icon>
                                                            </template>
                                                            <span>Delete</span>
                                                        </v-tooltip>
                                                    </v-list-item-icon>
                                                </v-list-item>

                                                </div>
                                                <div v-else>
                                                <v-list-item class="d-flex">

                                                <!-- <v-checkbox
                                                    v-model="item.visible"
                                                ></v-checkbox> -->
                                                    <v-list-item-content
                                                        @click="questionClick(item, index, indexElement)"
                                                    >
                                                        <v-list-item-title>{{item.valueName}} - {{ item.name }}</v-list-item-title>

                                                        <v-tooltip bottom  v-if="item.title">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-list-item-subtitle
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    <span v-html="item.title[localProjectData.language.code]"></span>
                                                                </v-list-item-subtitle>
                                                            </template>
                                                            <span>{{getContentTooltip(item.title, localProjectData.content, localProjectData.language.code)}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom  v-if="item.html">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-list-item-subtitle
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    <span v-html="item.html[localProjectData.language.code]"></span>
                                                                </v-list-item-subtitle>
                                                            </template>
                                                            <span>{{getContentTooltip(item.html, localProjectData.content, localProjectData.language.code)}}</span>
                                                        </v-tooltip>
                                                    </v-list-item-content>
                                                    <v-list-item-icon @click.stop="openDuplicateDialog(item, index)" :disabled="dialogOpen" class="align-self-center">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-bind="attrs" v-on="on">{{ icons.mdiContentCopy }}</v-icon>
                                                        </template>
                                                        <span>Duplicate</span>
                                                    </v-tooltip>
                                                    </v-list-item-icon>
                                                    <v-list-item-icon @click="deleteElement(index, indexElement)" class="align-self-center">
                                                        <v-tooltip>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                v-bind="attrs"
                                                                v-on="on">{{icons.mdiDeleteOutline}}</v-icon>
                                                            </template>
                                                            <span>Delete</span>
                                                        </v-tooltip>
                                                    </v-list-item-icon>

                                                </v-list-item>
                                            </div>
                                            </v-card>
                                        </draggable>


                                    </v-list>
                                </v-card-text>
                                <v-card-text>
                                    <div
                                        class="d-flex justify-center">
                                        <v-btn
                                            outlined
                                            color="info"
                                            v-if="isFromScratch"
                                            @click="openSection"
                                        >
                                            Add new section
                                            <v-icon>
                                                {{ icons.mdiPlus }}
                                            </v-icon>
                                        </v-btn>
                                        <v-dialog
                                                v-model="isNewSectionDialogOpen"
                                                width="500"
                                                @click:outside="resetNewSection"
                                                >

                                                <v-card>
                                                    <v-card-title class="text-h5 grey lighten-2">
                                                        Section Name
                                                    </v-card-title>

                                                    <v-card-text
                                                        v-if="localProjectData.language"
                                                    >
                                                        <v-form ref="sectionForm">

                                                            <v-text-field
                                                                v-model="newSection.name"
                                                                label="Section"
                                                                outlined
                                                                placeholder="Screener"
                                                                hide-details="auto"
                                                                dense
                                                                class="mb-4"
                                                                :rules="[validators.required, validators.alphaDashValidator]"
                                                            ></v-text-field>

                                                            <v-text-field
                                                                v-model="newSection.prefix"
                                                                label="Section prefix"
                                                                outlined
                                                                placeholder="S/E_Flow/Q/C/..."
                                                                hide-details
                                                                dense
                                                                class="mb-4"
                                                                :rules="[validators.required, validators.alphaDashValidator]"
                                                            ></v-text-field>

                                                            <v-textarea
                                                                v-model="newSection.description[localProjectData.language.code]"
                                                                label="Description"
                                                                outlined
                                                                placeholder="This is section is for..."
                                                                hide-details
                                                                dense
                                                                rows="3"
                                                                auto-grow
                                                            ></v-textarea>
                                                        </v-form>
                                                    </v-card-text>

                                                    <v-divider></v-divider>

                                                    <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        @click="resetNewSection">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn
                                                        color="primary"
                                                        outlined
                                                        @click="addNewSection"
                                                        v-if="newSection.index === undefined"
                                                    >
                                                        Add
                                                    </v-btn>
                                                    <v-btn
                                                        color="primary"
                                                        outlined
                                                        @click="updateSection(newSection)"
                                                        v-else
                                                    >
                                                        Update
                                                    </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                                </v-dialog>

                                    </div>

                                </v-card-text>
                            </v-tab-item>

                            <!-- Translation Tab -->
                            <!--<v-tab-item>
                                <v-row>
                                    <v-col cols="12" md="12" sm="12">
                                        <v-card  class="overflow-x-auto">

                                            <v-card-text v-if="localProjectData.json && localProjectData.languages">
                                                <v-data-table
                                                    hide-default-header
                                                    hide-default-footer
                                                    :items-per-page="-1"
                                                    :headers="translationHeaders"
                                                    :items="localProjectData.json.pages"
                                                    dense
                                                    >
                                                    <template v-slot:header>
                                                        <tr>
                                                            <th class="text-left">
                                                                Questions
                                                            </th>
                                                            <th class="text-left" v-for="header in localProjectData.languages" :key="header.code">
                                                                {{ header.name }}
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <td class="group-name" :colspan="localProjectData.languages.length+1">Categories</td>
                                                        </tr>

                                                        <tr v-if="localProjectData.content.testCat">
                                                            <td>Test Category</td>

                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                <v-textarea
                                                                    auto-grow
                                                                    rows="1"
                                                                    v-model="localProjectData.content.testCat.translation[header.code]"
                                                                    hide-details
                                                                    class="pt-0 mt-0"
                                                                    placeholder="Translation...">
                                                                </v-textarea>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="localProjectData.content.clutterCat1">
                                                            <td>Clutter Category 1</td>

                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                <v-textarea
                                                                    auto-grow
                                                                    rows="1"
                                                                    v-model="localProjectData.content.clutterCat1.translation[header.code]"
                                                                    hide-details
                                                                    class="pt-0 mt-0"
                                                                    placeholder="Translation...">
                                                                </v-textarea>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="localProjectData.content.clutterCat2">
                                                            <td>Clutter Category 2</td>

                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                <v-textarea
                                                                    auto-grow
                                                                    rows="1"
                                                                    v-model="localProjectData.content.clutterCat2.translation[header.code]"
                                                                    hide-details
                                                                    class="pt-0 mt-0"
                                                                    placeholder="Translation...">
                                                                </v-textarea>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="localProjectData.content.clutterCat3">
                                                            <td>Clutter Category 3</td>

                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                <v-textarea
                                                                    auto-grow
                                                                    rows="1"
                                                                    v-model="localProjectData.content.clutterCat3.translation[header.code]"
                                                                    hide-details
                                                                    class="pt-0 mt-0"
                                                                    placeholder="Translation...">
                                                                </v-textarea>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="localProjectData.content.clutterCat4">
                                                            <td>Clutter Category 4</td>

                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                <v-textarea
                                                                    auto-grow
                                                                    rows="1"
                                                                    v-model="localProjectData.content.clutterCat4.translation[header.code]"
                                                                    hide-details
                                                                    class="pt-0 mt-0"
                                                                    placeholder="Translation..."
                                                                    >
                                                                </v-textarea>
                                                            </td>
                                                        </tr>

                                                    </template>








                                                    <template v-slot:item="{ item }">

                                                        <tr v-bind:key="`${item.name}`"
                                                        >

                                                            <td class="name-row" >{{item.name}}</td>
                                                            <td class="name-row" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                <v-textarea
                                                                    :readonly="idx==0"
                                                                    auto-grow
                                                                    rows="1"
                                                                    hide-details
                                                                    class="pt-0 mt-0"
                                                                    v-model="item.description[header.code]"
                                                                    placeholder="Translation...">
                                                                </v-textarea>
                                                            </td>

                                                        </tr>

                                                        <template v-for="element in item.elements">


                                                            <template v-if="element.type == 'group'">

                                                            <template v-for="element in element.elements">
                                                            <tr v-bind:key="`${element.name}`" v-if="element.name">
                                                                <td class="group-name" :colspan="localProjectData.languages.length+1">{{ element.name }}</td>

                                                            </tr>
                                                            <template v-for="(value, key) in textMapping">
                                                                <template v-if="element[key]">
                                                                        <tr v-bind:key="`${item.name}-${element.name}-${key}`">
                                                                            <td>{{value}}</td>

                                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">

                                                                                <v-textarea
                                                                    :readonly="idx==0"
                                                                                    auto-grow
                                                                                    rows="1"
                                                                                    hide-details
                                                                                    class="pt-0 mt-0"
                                                                                    v-model="element[key][header.code]"
                                                                                    placeholder="Translation...">
                                                                                </v-textarea>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                            </template>
                                                            <template v-if="element.choices">
                                                                <tr v-bind:key="`${element.name}-choices`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Choices</td>

                                                                </tr>
                                                                <template v-for="(choice) in element.choices">

                                                                    <tr v-bind:key="`${element.name}-choices-${choice.value}`">
                                                                        <td>{{ choice.value }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                    :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="choice.text[header.code]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>

                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>
                                                            <template v-if="element.themes">
                                                                <tr v-bind:key="`${element.name}-themes`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Themes</td>

                                                                </tr>
                                                                <template v-for="(theme, themeIdx) in element.themes">

                                                                    <tr v-bind:key="`${element.name}-themes-${themeIdx}`">
                                                                        <td>Theme</td>

                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                        <v-textarea
                                                                    :readonly="idx==0"
                                                                            auto-grow
                                                                            rows="1"
                                                                            hide-details
                                                                            class="pt-0 mt-0"
                                                                            v-model="theme.title[header.code]"
                                                                            placeholder="Translation...">
                                                                        </v-textarea>
                                                                        </td>
                                                                    </tr>
                                                                <template v-for="(themeRow, themeRowIdx) in theme.rows">
                                                                        <tr v-bind:key="`${element.name}-themes-${themeIdx}-row-${themeRowIdx}`">
                                                                            <td>{{ themeRow.value }}</td>
                                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                                <v-textarea
                                                                    :readonly="idx==0"
                                                                                    auto-grow
                                                                                    rows="1"
                                                                                    hide-details
                                                                                    class="pt-0 mt-0"
                                                                                    v-model="themeRow.text[header.code]"
                                                                                    placeholder="Translation...">
                                                                                </v-textarea>

                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                            </template>

                                                            <template v-if="element.columns">
                                                                <tr v-bind:key="`${element.name}-columns`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Columns</td>

                                                                </tr>
                                                                <template v-for="(column) in element.columns">
                                                                    <tr v-bind:key="`${element.name}-columns-${column.value}`" v-if="column.value">
                                                                        <td>{{ column.value }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                    :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="column.text[header.code]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>

                                                                        </td>
                                                                    </tr>
                                                                    <tr v-bind:key="`${element.name}-columns-${column.name}`" v-else>
                                                                        <td>{{ column.name }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                    :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="column.title[header.code]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>

                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>

                                                            <template v-if="element.rows">
                                                                <tr v-bind:key="`${element.name}-rows`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Rows</td>

                                                                </tr>
                                                                <template v-for="(row) in element.rows">
                                                                    <tr v-bind:key="`${element.name}-rows-${row.value}`">
                                                                        <td>{{ row.value }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                                :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="row.text[`${header.code}`]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>

                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>
                                                            </template>





























                                                            </template>
                                                            <template v-else>
                                                                <tr v-bind:key="`${element.name}`" v-if="element.name">
                                                                <td class="group-name" :colspan="localProjectData.languages.length+1">{{ element.name }}</td>

                                                            </tr>
                                                            <template v-for="(value, key) in textMapping">
                                                                <template v-if="element[key]">
                                                                        <tr v-bind:key="`${item.name}-${element.name}-${key}`">
                                                                            <td>{{value}}</td>

                                                                            <td class="text-left to-update" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                                <v-textarea
                                                                                    :readonly="idx==0"
                                                                                    auto-grow
                                                                                    rows="1"
                                                                                    hide-details
                                                                                    class="pt-0 mt-0"
                                                                                    v-model="element[key][header.code]"
                                                                                    placeholder="Translation...">
                                                                                </v-textarea>
                                                                            </td>
                                                                        </tr>
                                                                    </template>

                                                            </template>
                                                            <template v-if="element.choices">
                                                                <tr v-bind:key="`${element.name}-choices`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Choices</td>

                                                                </tr>
                                                                <template v-for="(choice) in element.choices">

                                                                    <tr v-bind:key="`${element.name}-choices-${choice.value}`">
                                                                        <td>{{ choice.value }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                    :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="choice.text[header.code]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>

                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>
                                                            <template v-if="element.themes">
                                                                <tr v-bind:key="`${element.name}-themes`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Themes</td>

                                                                </tr>
                                                                <template v-for="(theme, themeIdx) in element.themes">

                                                                    <tr v-bind:key="`${element.name}-themes-${themeIdx}`">
                                                                        <td>Theme</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                        <v-textarea
                                                                    :readonly="idx==0"
                                                                            auto-grow
                                                                            rows="1"
                                                                            hide-details
                                                                            class="pt-0 mt-0"
                                                                            v-model="theme.title[header.code]"
                                                                            placeholder="Translation...">
                                                                        </v-textarea>
                                                                    </td>
                                                                    </tr>
                                                                <template v-for="(themeRow, themeRowIdx) in theme.rows">
                                                                        <tr v-bind:key="`${element.name}-themes-${themeIdx}-row-${themeRowIdx}`">
                                                                            <td>{{ themeRow.value }}</td>
                                                                            <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                                <v-textarea
                                                                                    :readonly="idx==0"
                                                                                    auto-grow
                                                                                    rows="1"
                                                                                    hide-details
                                                                                    class="pt-0 mt-0"
                                                                                    v-model="themeRow.text[header.code]"
                                                                                    placeholder="Translation...">
                                                                                </v-textarea>

                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                            </template>

                                                            <template v-if="element.columns">
                                                                <tr v-bind:key="`${element.name}-columns`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Columns</td>

                                                                </tr>
                                                                <template v-for="(column) in element.columns">
                                                                    <tr v-bind:key="`${element.name}-columns-${column.value}`" v-if="column.value">
                                                                        <td>{{ column.value }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                    :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="column.text[header.code]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-bind:key="`${element.name}-columns-${column.name}`" v-else>
                                                                        <td>{{ column.name }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                    :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="column.title[header.code]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>

                                                            <template v-if="element.rows">
                                                                <tr v-bind:key="`${element.name}-rows`">
                                                                    <td class="choice-name" :colspan="localProjectData.languages.length+1">Rows</td>

                                                                </tr>
                                                                <template v-for="(row) in element.rows">
                                                                    <tr v-bind:key="`${element.name}-rows-${row.value}`">
                                                                        <td>{{ row.value }}</td>
                                                                        <td class="text-left" v-for="(header, idx) in localProjectData.languages" :key="`${idx}`">
                                                                            <v-textarea
                                                                                :readonly="idx==0"
                                                                                auto-grow
                                                                                rows="1"
                                                                                hide-details
                                                                                class="pt-0 mt-0"
                                                                                v-model="row.text[`${header.code}`]"
                                                                                placeholder="Translation...">
                                                                            </v-textarea>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>

                                                            </template>


                                                        </template>
                                                    </template>

                                                </v-data-table>

                                        </v-card-text>
                                        </v-card>
                                    </v-col>

                                </v-row>




                            </v-tab-item>-->
                            <v-tab-item>
                                <v-alert
                                    v-model="translationAlert"
                                    dense
                                    outlined
                                    type="error"
                                >
                                    {{ alertText }}
                                </v-alert>
                                <questionnaire-version
                                    :versions="versionsItems"
                                    :questionnaire-id="localProjectData.id"
                                    :loading="versionsLoading"

                                >

                                </questionnaire-version>
                            </v-tab-item>
                            <v-tab-item
                            v-if="prgmPermission">
                                <app-card-code
                                    :code="JSON.stringify(localProjectData, null, 2)"
                                    codeLanguage="javascript"
                                    :isCodeCollapsed="true"
                                    >
                                    
                                    <template slot="title" >
                                        Project Info
                                    </template>
                                    
                                </app-card-code>
                            </v-tab-item>

                        </v-tabs-items>

                    </v-card>

            </v-card-text>

        </v-card>

        <v-navigation-drawer
            v-model="isQuestionDrawerActive"
            touchless
            app
            right
            width="720"
            class="overlay"
            temporary
        >
            <question-drawer-content
                :is-active="isQuestionDrawerActive"
                :question="question"
                :content="localProjectData.content"
                :defaultLang="localProjectData.language"
                :question-label-list="questionLabelList"
                :questions-with-choices="questionsWithChoices"
                :variable-suggestions="variableSuggestions"
                :stim-suggestions="stimSuggestions"
                :collection-method="localProjectData.collection_method"
                @update-item="updateQuestion"
                v-if="localProjectData.language"
            >

            </question-drawer-content>
        </v-navigation-drawer>
        <question-type
            :isDialogVisible.sync="isQuestionTypeDialog"
            :index-page="indexPage"
            :question-label-list="questionLabelList"
            :defaultLang="localProjectData.language"
            :questions-with-choices="questionsWithChoices"
            :variable-suggestions="variableSuggestions"
            :cell-count="localProjectData.content.cellCount"
            :research-method="localProjectData.research_method"
            @add-element="addElement"
            v-if="localProjectData.language"
        >

        </question-type>
        <translation-dialog-edit
            :is-translation-dialog-open.sync="isTranslationDialogOpen"
            :project-data="localProjectData"
            :languageOptions="languageOptions"
            :translationLoading="translationLoading"
            @translate="aiTranslation"
        ></translation-dialog-edit>

        <paper-questionnaire-dialog
            :is-paper-questionnaire-dialog-open.sync="isPaperQuestionnaireDialogOpen"
            :languageOptions="localProjectData.languages"
            :loading.sync="exportLoading"
            @export="download"
            v-if="localProjectData.languages"
        ></paper-questionnaire-dialog>
        <supplemental-info-dialog
            :is-dialog-visible.sync="isProjectInfoDialogOpen"
            :project-data="localProjectData"
            :language-options="languageOptions"
            :language-loading="languageLoading"
            @save="save"
        >
        </supplemental-info-dialog>

        <quota-dialog
            :is-quota-dialog-open.sync="isQuotaDialogOpen"
            :project-data="localProjectData"
            :loading.sync="updateQuestionnaireLoading"
            @save="save"
        >
        </quota-dialog>
        <piping-var-dialog
            :is-piping-var-dialog-open.sync="isPipingVarDialogOpen"
            :pipe="pipingVar"
            @update="updatePipe"
        >

        </piping-var-dialog>
        <v-dialog
            v-model="validationConfirmation"
            persistent
            max-width="450"
            >
            <v-card>
                <v-card-title class="text-h5">
                    Confirmation
                </v-card-title>
                <v-card-text>
                    Have you received validation and confirmation from the client on this questionnaire?
                </v-card-text>
                <v-card-text v-if="versionsItems.filter(version => version.questionnaire == localProjectData.id).length > 0">
                    <v-form
                        ref="versionConfirmForm"
                    >
                        <span>We've noticed you are about to validate a questionnaire that has been validated before, please add a note to inform the prgm and PM teams on what has changed!</span>
                        <v-textarea
                            v-model="versionNotes"
                            outlined
                            label="Notes"
                            :rules="[validators.required]"
                            class="pt-2"
                        >

                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="validationConfirmation = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="success"
                    text
                    @click="BuildQuestionnaire"
                >
                    Yes
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
            <v-dialog v-model="dialogOpen" max-width="600px" overlay-opacity="0">
            <v-card>
                <v-card-title class="headline">Rename Label</v-card-title>
                <v-card-text>
                <v-form
                @submit.prevent="confirmDuplicate"
                ref="duplicateQuestionsForm">
                <v-row v-for="(item, index) in renameList" :key="index">
                <v-col cols="6">
                    <span>{{ item.label }}</span>
                </v-col>
                  <v-col cols="6">
                    <v-text-field
                        v-model="item.newLabel"
                        label="New label name"
                        :rules="[validators.duplicatedLabelValidator(item.label, index), validators.decipherLabelValidator]"
                        dense
                        outlined
                        hide-details="auto"
                    ></v-text-field>
                    </v-col>
                   </v-row>
                </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancelDuplicate">Cancel</v-btn>
                <v-btn color="primary" text @click="confirmDuplicate">Confirm</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>


    </div>
</template>

<script>
import { ref, watch, onMounted, onUnmounted } from '@vue/composition-api'
import {
    mdiHeart, mdiShareVariant, mdiPencil, mdiTrashCanOutline, mdiPlus, mdiContentCopy,
    mdiTextBoxEditOutline, mdiSetSplit, mdiFormatAlignJustify, mdiDeleteOutline,
    mdiDotsHorizontal, mdiContentSaveOutline, mdiDownloadBoxOutline, mdiFolderOpenOutline,
    mdiInformationOutline, mdiFileWordOutline, mdiTranslate, mdiPlaylistPlus,
    mdiContentSaveCheckOutline, mdiLockOpenAlertOutline, mdiClipboardAlertOutline, mdiCartPercent
} from '@mdi/js'
import store from '@/store'
import router from '@/router'
import _ from 'lodash-es'

import {
  required, requiredArray, alphaDashValidator, integerValidator, billingRuleValidator, decipherLabelValidator
} from '@core/utils/validation'

import surveyStoreModule from '../surveyStoreModule'
import useSurvey from '../useSurvey'

// Child Components
import QuestionDrawerContent from './questions/QuestionDrawerContent.vue'
import QuestionType from './questions/QuestionType.vue'
import TranslationDialogEdit from './translation/TranslationDialogEdit.vue'
import PaperQuestionnaireDialog from './PaperQuestionnaireDialog.vue'
import SupplementalInfoDialog from './supplemental/SupplementalInfoDialog.vue'
import QuotaDialog from './quotas/QuotaDialog.vue'
import PipingVarDialog from './supplemental/PipingVarDialog.vue'
import QuestionnaireVersion from './versions/QuestionnaireVersion.vue'
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'
import Draggable from "vuedraggable"

export default {
    template: '#table-template',
    components: {
        AppCardCode,
        Draggable,
        QuestionDrawerContent,
        QuestionType,
        TranslationDialogEdit,
        PaperQuestionnaireDialog,
        SupplementalInfoDialog,
        PipingVarDialog,
        QuestionnaireVersion,
        QuotaDialog
    },
    setup(props, { refs, root }) {
        const SURVEY_APP_STORE_MODULE_NAME = 'app-survey'

        // Register module dynamically
        if (!store.hasModule(SURVEY_APP_STORE_MODULE_NAME)) {
            store.registerModule(SURVEY_APP_STORE_MODULE_NAME, surveyStoreModule)
        }

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(SURVEY_APP_STORE_MODULE_NAME)) {
                store.unregisterModule(SURVEY_APP_STORE_MODULE_NAME)
            }
        })

        const localProjectData = ref({})
        const isQuestionDrawerActive = ref(false)
        const question = ref({})

        const isQuestionTypeDialog = ref(false)
        const isTranslationDialogOpen = ref(false)
        const isPaperQuestionnaireDialogOpen = ref(false)
        const isProjectInfoDialogOpen = ref(false)
        const isQuotaDialogOpen = ref(false)
        const deleteQuestionnaireDialogOpen = ref(false)
        const isNewSectionDialogOpen = ref(false)
        const newSection = ref({})

        const pipingCheck = ref([])
        const pipingVar = ref({})
        const isPipingVarDialogOpen = ref(false)

        const alertText = ref('')
        const isFromScratch = ref(false)

        const versionNotes = ref("")
        const validationConfirmation = ref(false)

        const dialogOpen = ref(false)
        const newLabel = ref("")
        const duplicateError = ref("")
        const questionToDuplicate = ref(null)
        const duplicateIndex = ref(null)
        const renameList = ref([])

        // Check Permissions cleanly via root context
        const projectPermission = root.$ability.can('read', 'project')
        const prgmPermission = root.$ability.can('update', 'forsta')

        const isDialogOpen = ref(false)
        const titleDialog = ref("")
        const stateDialog = ref("")
        const itemList = ref("")
        const indexPage = ref(0)
        const indexElement = ref(0)
        const indexGroupElement = ref(null)
        const questionLabelList = ref(new Set())
        const questionsWithChoices = ref([])
        const translationAlert = ref(false)

        const surveyTab = ref(null)
        const surveyTabItems = ref([
          { text: 'Designer', display: projectPermission },
          { text: 'Translation', display: projectPermission },
          { text: 'JSON Viewer', display: prgmPermission },
          { text: 'Versions', display: projectPermission }
        ])

        const variableSuggestions = ref([])
        const isUploadSelecting = ref(false)

        // Destructure shared composable logic
        const {
            projectData, fetchProject, exportLoading, downloadQuestionnaire, updateQuestionnaire,
            updateQuestionnaireLoading, deleteQuestionnaire, getContentTooltip, textMapping,
            languageOptions, languageLoading, fetchLanguages, exportToCSVFile, importFromCSVFile,
            translationLoading, deleteQuestionnaireLoading, addQuestionnaireVersion, listQuestionLabel,
            splitIfStartsWithPrefix, fetchStimSuggestions, stimSuggestions, fetchVersions,
            versionsItems, versionsLoading, isObjectEmpty
        } = useSurvey()

        const resetSection = () => {
            const langCode = localProjectData.value.language?.code || 'en'
            newSection.value = {
                name: '',
                prefix: '',
                description: { [langCode]: '' }
            }
        }

        const searchJSON = (obj, prefix, keySearch) => {
            const results =[]
            const search = (target) => {
                for (const key in target) {
                    const value = target[key]
                    if (typeof value === 'object' && value !== null) {
                        search(value)
                    } else if (typeof value === 'string' && value.startsWith(prefix) && key === keySearch) {
                        results.push(value)
                    }
                }
            }
            search(obj)
            return results
        }

        const normalizeProjectData = (pData) => {
            let content = {
                clutterCat1: "", clutterCat2: "", clutterCat3: "", clutterCat4: "", testCat: "",
                brand: pData.brand, usageTime: 0, cellCount: pData.phase,
                price: Array(pData.phase).fill(0), competitor: Array(pData.phase).fill(null),
                sample_findability: Array(pData.phase).fill(0), testProduct: Array(pData.phase).fill(null),
                sample_split: Array(pData.phase).fill(0), sample_flash: Array(pData.phase).fill(0),
                sample_ef: Array(pData.phase).fill(0), finda: Array(pData.phase).fill(null),
                phases: Array(pData.phase).fill(null)
            }

            if (pData.methodology === 'innocompass') {
                content.ad = false
                content.concept = false
            }

            if (!isObjectEmpty(pData.content)) {
                content = {
                    ...content,
                    ...pData.content
                }
            }
            if (content.cellCount === undefined) content.cellCount = pData.phase

            const findaMatches = searchJSON(pData.json.pages, 'finda', 'pipe')
            findaMatches.forEach(findaLabel => {
                if (content[findaLabel] === undefined) {
                    content[findaLabel] = Array(content.cellCount).fill(null)
                }
            })

            if (content.testCat) {
                variableSuggestions.value =[
                    { label: "testProduct", value: pData.content.testProduct },
                    { label: "competitor", value: pData.content.competitor },
                    { label: "brand", value: pData.content.brand },
                    { label: "testCat", value: pData.content.testCat?.translation?.[pData.language.code] || '' },
                    { label: "usageTime", value: pData.content.usageTime },
                    { label: "clutterCat1", value: pData.content.clutterCat1?.translation?.[pData.language.code] || ''},
                    { label: "clutterCat2", value: pData.content.clutterCat2?.translation?.[pData.language.code] || ''},
                    { label: "clutterCat3", value: pData.content.clutterCat3?.translation?.[pData.language.code] || ''},
                    { label: "clutterCat4", value: pData.content.clutterCat4?.translation?.[pData.language.code] || ''},
                    { label: "price", value: pData.content.price }
                ]

                Object.keys(pData.content)
                    .filter(el => el.startsWith('finda'))
                    .forEach(findaLabel => {
                        variableSuggestions.value.push({ label: findaLabel, value: pData.content[findaLabel] })
                    })
            }

            const langTranslations = pData.translations.map(lang => ({
                id: lang.language.id, code: lang.language.code, name: lang.language.name
            }))

            pData.translations = langTranslations
            pData.languages =[pData.language, ...langTranslations]

            if (!pData.json) {
                pData.json = { pages: [] }
            }

            if (!Array.isArray(pData.json.pages)) {
                pData.json.pages = []
            }

            return { ...pData, content }
        }

        const download = (lang) => {
            localProjectData.value.export_lang = lang.map(language => language.code)
            downloadQuestionnaire(localProjectData.value)
        }

        const save = (data = localProjectData) => {
            if (data.value.translationUpdated) {
                data.value.quest_translations = data.value.translations.map(lang => ({ language: lang.id }))
            }
            updateQuestionnaire(data.value)
            isProjectInfoDialogOpen.value = false
        }

        const updateQuestion = (q) => {
            if (indexGroupElement.value == null) {
                localProjectData.value.json.pages[indexPage.value].elements[indexElement.value] = q
            } else {
                localProjectData.value.json.pages[indexPage.value].elements[indexElement.value].elements[indexGroupElement.value] = q
            }
            save(localProjectData)
        }

        const questionClick = (q, page, element, groupIndex = null) => {
            questionLabelList.value = new Set(listQuestionLabel(localProjectData.value.json.pages))
            questionLabelList.value.delete(splitIfStartsWithPrefix(q.valueName, "QX_"))
            questionLabelList.value.delete(splitIfStartsWithPrefix(q.name, "QX_"))

            questionsWithChoices.value = listQuestionsWithChoices(q.name)

            isQuestionDrawerActive.value = true
            question.value = q
            indexPage.value = page
            indexElement.value = element
            indexGroupElement.value = groupIndex
        }

        const openQuestionType = (index) => {
            questionLabelList.value = new Set(listQuestionLabel(localProjectData.value.json.pages))
            indexPage.value = index
            questionsWithChoices.value = listQuestionsWithChoices('')
            isQuestionTypeDialog.value = true
        }

        const listQuestionsWithChoices = (name) => {
            return localProjectData.value.json.pages.flatMap(page => 
                (page.elements || []).flatMap(element => {
                    if (element.choices && element.name !== name) return[element.name]
                    if (element.rows && element.name !== name) return [element.name]
                    if (element.type === 'group') {
                        return element.elements.flatMap(q => {
                            if ((q.choices || q.rows) && q.name !== name) return [q.name]
                            return []
                        })
                    }
                    return[]
                })
            ).filter(Boolean)
        }

        const addElement = (index, q) => {
            if (index != null && q) {
                if (!localProjectData.value.json.pages[index].elements) {
                    localProjectData.value.json.pages[index].elements =[]
                }
                localProjectData.value.json.pages[index].elements.push(q.element)
            }
            isQuestionTypeDialog.value = false
            resetQuestionNumber(index)
            save(localProjectData)
        }

        const openDuplicateDialog = (q, index) => {
            questionLabelList.value = new Set(listQuestionLabel(localProjectData.value.json.pages))
            questionToDuplicate.value = q
            duplicateIndex.value = index
            dialogOpen.value = true
            duplicateError.value = ""

            if (q.elements && Array.isArray(q.elements)) {
                renameList.value = q.elements.map(sub => ({ label: sub.name, newLabel: `${sub.name}_1` }))
            } else {
                renameList.value =[{ label: q.name, newLabel: `${q.name}_1` }]
            }

            if (refs.duplicateQuestionsForm?.resetValidation) {
                refs.duplicateQuestionsForm.resetValidation()
            }
        }

        const cancelDuplicate = () => {
            dialogOpen.value = false
            newLabel.value = duplicateError.value = ""
            questionToDuplicate.value = null
            if (refs.duplicateQuestionsForm?.reset) {
                refs.duplicateQuestionsForm.reset()
            }
        }

        const confirmDuplicate = () => {
            if (!refs.duplicateQuestionsForm?.validate()) return

            const localElement = JSON.parse(JSON.stringify(questionToDuplicate.value))

            if (localElement.elements && Array.isArray(localElement.elements)) {
                renameList.value.forEach((item, idx) => {
                    localElement.elements[idx].name = item.newLabel.trim()
                })
            } else {
                localElement.name = renameList.value[0].newLabel.trim()
            }

            addElement(duplicateIndex.value, { element: localElement })
            dialogOpen.value = false
        }

        const deleteElement = (pageIdx, elIdx) => {
            const element = localProjectData.value.json.pages[pageIdx].elements[elIdx]
            if (element.pipe) delete localProjectData.value.content[element.pipe]
            localProjectData.value.json.pages[pageIdx].elements.splice(elIdx, 1)
        }

        const downloadTranslation = () => {
            let locales = localProjectData.value.languages.map(lang => lang.code)
            exportToCSVFile(`${localProjectData.value.job_number} - ${localProjectData.value.job_name} - Translation.csv`, localProjectData.value.json.pages, locales)
        }

        const uploadTranslation = (el) => {
            if (el.target.files.length < 1) return
            importFromCSVFile(localProjectData.value.json.pages, el.target.files[0])
        }

        const onUploadClick = () => {
            isUploadSelecting.value = true
            window.addEventListener('focus', () => isUploadSelecting.value = false, { once: true })
            if (refs.uploader) refs.uploader.click()
        }

        const aiTranslation = (data) => {
            const translateAll = data.translationOptions === '1'
            // Trigger Translation logic here 
        }

        const isSectionFormValid = () => refs.sectionForm?.validate() || false

        const addNewSection = () => {
            if (isSectionFormValid()) {
                if (isObjectEmpty(projectData.value.content)) {
                    isProjectInfoDialogOpen.value = true
                } else {
                    const section = {
                        name: newSection.value.name,
                        prefix: newSection.value.prefix,
                        title: { [localProjectData.value.language.code]: newSection.value.name },
                        description: newSection.value.description,
                        elements:[]
                    }
                    if (newSection.value.prevIndex >= 0) {
                        localProjectData.value.json.pages.splice(newSection.value.prevIndex + 1, 0, section)
                    } else {
                        localProjectData.value.json.pages.push(section)
                    }
                    isNewSectionDialogOpen.value = false
                    resetSection()
                }
            }
        }

        const resetNewSection = () => {
            resetSection()
            isNewSectionDialogOpen.value = false
        }

        const deleteSection = index => localProjectData.value.json.pages.splice(index, 1)

        const appendSection = (index) => {
            resetNewSection()
            newSection.value.prevIndex = index
            isNewSectionDialogOpen.value = true
        }

        const openSection = () => {
            resetSection()
            isNewSectionDialogOpen.value = true
        }

        const updateSection = (section) => {
            if (isSectionFormValid()) {
                const index = section.index
                if (index !== undefined) {
                    Object.assign(localProjectData.value.json.pages[index], {
                        name: section.name,
                        prefix: section.prefix,
                        description: section.description
                    })
                    resetQuestionNumber(index)
                }
                resetNewSection()
                save()
            }
        }

        const sectionClick = (section, index) => {
            newSection.value = { ...section, index }
            isNewSectionDialogOpen.value = true
        }

        const resetQuestionNumber = (index) => {
            const page = localProjectData.value.json.pages[index]
            if (page.prefix) {
                let iter = 1
                page.elements.forEach((element) => {
                    if (element.type === 'group') {
                        element.elements.forEach((q) => q.valueName = `${page.prefix}_${iter++}`)
                    } else {
                        element.valueName = `${page.prefix}_${iter++}`
                    }
                })
            }
        }

        const checkPipingVar = (data) => {
            // data.json.pages.forEach((page, pageIdx) => {
                // page.elements.forEach((element, elementIdx) => {
            (data.json?.pages ?? []).forEach((page, pageIdx) => {
                (page.elements ?? []).forEach((element, elementIdx) => {
                    if (element.piping_var_prefix !== undefined && !element.pipe) {
                        pipingCheck.value.push({
                            cellCount: data.content.cellCount,
                            question: element.class || element.name,
                            id: null,
                            prefix: element.piping_var_prefix,
                            value:[],
                            sectionIndex: pageIdx,
                            elementIndex: elementIdx
                        })
                    }
                })
            })
        }

        const updatePipe = (pipe) => {
            let prefixMatches = Object.keys(localProjectData.value.content).filter(el => el.startsWith(pipe.prefix))
            let id = null
            let iteration = 1

            while (true) {
                id = iteration === 1 ? pipe.prefix : `${pipe.prefix}_${iteration}`
                if (!prefixMatches.includes(id)) break
                iteration++
            }
            
            localProjectData.value.content[id] = pipe.value
            const targetElement = localProjectData.value.json.pages[pipe.sectionIndex].elements[pipe.elementIndex]
            targetElement.pipe = id

            const reg = /{finda.*?}/gi
            for (const value of Object.values(targetElement.elements)) {['title', 'description', 'html'].forEach(attr => {
                    if (value[attr]) {
                        Object.keys(value[attr]).forEach(lang => {
                            value[attr][lang] = value[attr][lang].replace(reg, `{${id}}`)
                        })
                    }
                })
            }

            isPipingVarDialogOpen.value = false
            pipingCheck.value.pop()
            save(localProjectData)
        }

        const BuildQuestionnaire = () => {
            const isValid = refs.versionConfirmForm ? refs.versionConfirmForm.validate() : true
            if (!isValid) return

            validationConfirmation.value = false
            const notes = versionsItems.value.length > 0 ? versionNotes.value : "Initial Validation"
            addQuestionnaireVersion({ questionnaire: localProjectData.value.id, notes }, versionsItems.value)
        }

        const validationConfirmed = () => {
            alertText.value = ''
            const rcda = searchJSON(localProjectData.value.json.pages, 'rcda_Inst', 'name')
            if (rcda.length === 0) {
                alertText.value = `The RCDA text is missing. `
            }
            translationAlert.value = false
            validationConfirmation.value = true
        }

        const getVersions = () => {
            translationAlert.value = false
            fetchVersions({ job_number: localProjectData.value.job_number })
        }

        onMounted(async () => {
            await fetchProject()
            await fetchStimSuggestions({ project_country: projectData.value.project })
            fetchLanguages()
            if (router.currentRoute.params.new) isProjectInfoDialogOpen.value = true
        })

        watch(projectData, () => {
            localProjectData.value = normalizeProjectData(JSON.parse(JSON.stringify(projectData.value)))
            checkPipingVar(localProjectData.value)
            resetSection()
            if (isObjectEmpty(projectData.value.content)) isProjectInfoDialogOpen.value = true
            isFromScratch.value = localProjectData.value.json.pages.length === 0

            const localQuotas = localProjectData.value.quotas
            if (!localQuotas || isObjectEmpty(localQuotas) || localQuotas.length === 0) {
                const quotaHeaders =[
                    { text: "Question", align: "start", sortable: false, value: "question" },
                    { text: "Choices", value: "choices" }
                ]

                projectData.value.content.phases?.forEach((phaseName, index) => {
                    quotaHeaders.push({
                        text: phaseName,
                        value: `col_${index + 1}`,
                        quota: projectData.value.content.sample_split[index]
                    })
                })
                quotaHeaders.push({ text: "", value: "actions", active: false, sortable: false })

                localProjectData.value.quotas = { headers: quotaHeaders, quotas:[] }
            }
        })

        watch(pipingCheck, (newVal) => {
            if (newVal.length > 0) {
                pipingVar.value = newVal[newVal.length - 1]
                isPipingVarDialogOpen.value = true
            }
        })

        const calculateTextFieldRows = (e, text) => {
            if (!text) return 1
            return Math.ceil(text.length / 50)
        }

        const duplicatedLabelValidator = (originalLabel, index) => {
            return (value) => {
                if (!value || !value.trim()) return "Label cannot be empty."
                if (value.trim() === originalLabel) return "Label must be different from the original."
                if (questionLabelList.value.has(value.trim())) return "Question label already exists."
                if (renameList.value.some((item, idx) => index !== idx && item.newLabel === value.trim())) {
                    return "Question label already exists."
                }
                return true
            }
        }

        watch(validationConfirmation, (newVal) => {
            if (!newVal) {
                versionNotes.value = ""
                if (refs.versionConfirmForm) refs.versionConfirmForm.resetValidation()
            }
        })

        return {
            questionClick, isQuestionDrawerActive, question, updateQuestion, isQuestionTypeDialog,
            questionLabelList, questionsWithChoices, variableSuggestions, surveyTab, surveyTabItems,
            textMapping, languageOptions, languageLoading, downloadTranslation, uploadTranslation,
            isUploadSelecting, onUploadClick, aiTranslation, isTranslationDialogOpen,
            isPaperQuestionnaireDialogOpen, deleteQuestionnaireDialogOpen, isProjectInfoDialogOpen,
            isQuotaDialogOpen, isNewSectionDialogOpen, exportLoading, translationLoading,
            resetQuestionNumber, deleteQuestionnaireLoading, isFromScratch, updateQuestionnaireLoading,
            isDialogOpen, titleDialog, itemList, openQuestionType, indexPage, addElement, duplicateElement: () => {},
            deleteElement, getContentTooltip, dialogOpen, newLabel, duplicateError, openDuplicateDialog,
            cancelDuplicate, confirmDuplicate, renameList, localProjectData, download, save, addNewSection,
            appendSection, deleteSection, newSection, resetNewSection, openSection, updateSection,
            sectionClick, deleteQuestionnaire, projectPermission, prgmPermission, pipingVar,
            isPipingVarDialogOpen, updatePipe, calculateTextFieldRows, validationConfirmed, versionsItems,
            versionsLoading, getVersions, translationAlert, alertText, versionNotes, validationConfirmation,
            BuildQuestionnaire, stimSuggestions,

            icons: {
                mdiHeart, mdiShareVariant, mdiPencil, mdiTrashCanOutline, mdiPlus, mdiContentCopy,
                mdiTextBoxEditOutline, mdiSetSplit, mdiFormatAlignJustify, mdiDeleteOutline,
                mdiDotsHorizontal, mdiContentSaveOutline, mdiDownloadBoxOutline, mdiFolderOpenOutline,
                mdiInformationOutline, mdiFileWordOutline, mdiTranslate, mdiPlaylistPlus,
                mdiContentSaveCheckOutline, mdiLockOpenAlertOutline, mdiClipboardAlertOutline, mdiCartPercent
            },
            validators: {
                required, requiredArray, alphaDashValidator, integerValidator,
                billingRuleValidator, duplicatedLabelValidator, decipherLabelValidator
            }
        }
    }
}
</script>

<style lang="css" scoped>

.v-banner__text {
    background-color: #e85a00;
}
.step-cursor {
    cursor: pointer;
}

.card-cursor {
    cursor: grab;
}
.v-banner--single-line >>> div {
    max-height: 30px !important;
}

.alert {
    border-color:rgba(232, 90, 0, 0.5)
}
.regular {
    border-color:rgba(94, 86, 105, 0.14)
}

.v-tooltip__content >>> span {
    white-space: pre-wrap;
}

.name-row {
  background: #ddd;
  border-top: 1px solid black;
  }

  .group-name {
  background: #eee;
  }

  .choice-name {
    color: rgba(94, 86, 105, 0.68) !important;
    font-weight:bold
  }

    .to-update {
        border-left: 2px solid #f00
    }

</style>

<style lang="scss" scoped>



.app-customizer-toggler {
    position: fixed;
    top: 50%;
    transform: translateX(-50%);
    right: -22px;
    background: var(--v-warning-base);
  }


  .app-customizer {
    position: relative;
    z-index: 7;


    // Fixes Overlay is shown below SystemBar
    @at-root {
      .v-overlay {
        & + .v-application--wrap > .v-system-bar {
          z-index: 6 !important;
        }
      }
    }
  }


</style>
